<template>
    <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="2000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card class="box">
        <v-toolbar dense class="toolbar" flat color="white">
          <v-toolbar-title>Faculty By-Pass Login</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-row dense justify-center>
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                color="#0F2027"
                dense
                rounded
                required
                v-model="faculty"
                return-object
                :items="faculty_list"
                item-text="name"
                label="Search Faculty by name/code"
                outlined
                :loading="faculty_loader"
              />
            </v-col>
            <v-btn
              v-if="faculty != null"
              class="mb-2 button"
              @click="faculty_bypass()"
              :disabled="isallowed == false ? true : false"
            >
              Login
            </v-btn>
          </v-row>
          <v-row dense justify-center v-if="faculty != null">
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                label="Username"
                disabled
                v-model="faculty.uid"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                disabled
                v-model="faculty.email"
                label="Email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                disabled
                v-model="faculty.mobile_no"
                label="Mobile no."
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import "@/assets/css/color.css";
  
  export default {
    data: () => ({
      username: null,
      userid: null,
      show1: false,
      newPassword: null,
      cnfPassword: null,
      faculty: null,
      faculty_list: null,
      faculty_loader: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      all_users: [],
      login_loader: false,
      domain_id:"",isallowed:false,
    }),
    created(){
      this.domain_id = localStorage.getItem("EPS-org-domain-id")
    },
    methods: {
      copy(){
          this.username += this.domain_id
      },
      copyAt(mail) {
        this.username += mail
      },
      faculty_bypass() {
          this.username = this.faculty.uid
          this.bypasslogin()
      },
      bypasslogin() {
        if (this.username == null || this.username == "") {
          this.showSnackbar("#b71c1c", "Please enter username...!");
          return false;
        } else {
          const formData = {
            username: this.username,
            from: "Employee",
          };
          this.login_loader = true;
          axios
            .post("/management/bypass", formData)
            .then((res) => {
              if (res.data.flag == "YES") {
                this.showSnackbar("#4caf50", res.data.snackbar);
                //localStorage.setItem("awspath",res.data.awspath)
                localStorage.setItem("EPS-token", res.data.bypass_token);
                localStorage.setItem("EPS-tenant", res.data.bypass_tenant);
                localStorage.setItem("EPS-uid", res.data.bypass_uid);
                localStorage.setItem("EPS-ut", res.data.bypass_ut);
                localStorage.setItem("EPS-bypassed-by",res.data.bypassed_by);
  
                localStorage.setItem("username", res.data.username)
                localStorage.setItem("profile_image_path", res.data.profile_image_path)
                localStorage.setItem("profile_image_name", res.data.profile_image_name)
                
                localStorage.setItem(
                  "report-field",
                  JSON.stringify(res.data.bypass_rep_fields)
                );
                this.$session.start();
                sessionStorage.setItem("isDrawer",true);
              // this.$router.push("/home");
              // location.reload(); 
              window.location.href="/home";
              } else {
                this.showSnackbar("#b71c1c", res.data.snackbar);
              }
              this.login_loader = false;
            })
            .catch((error) => {
              this.showSnackbar("#b71c1c", "Something went wrong!!!");
              this.login_loader = false;
              window.console.log(error);
            });
        }
      },
  
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
    },
    mounted() {
      this.faculty_loader = true;
      axios
        .post("/management/get_faculties")
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.showSnackbar("#4caf50", res.data.snackbar);
            //localStorage.setItem("awspath",res.data.awspath)
            this.faculty_list = res.data.faculty_list;
              this.isallowed=res.data.isallowed
          } else {
              this.isallowed=res.data.isallowed
            this.showSnackbar("#b71c1c", res.data.snackbar);
          }
          this.faculty_loader = false;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.faculty_loader = false;
          window.console.log(error);
        });
    },
  };
  </script>
  
  <style></style>
  